import { Observable } from 'rxjs';
import { ListadoCuentasContablesResponseDTO } from 'src/app/data/dto/CuentasContablesDTO';

export abstract class CuentasContablesRepository {
    abstract listaCuentasContables(): Observable<ListadoCuentasContablesResponseDTO>;
}
